import React from 'react';
import { Checkbox } from '@mui/material';
import { CheckIcon } from 'src/Icons';

interface DefaultCheckBoxProps {
  disabled?: boolean;
  isChecked: boolean;
  onChange: (event?: any) => void;
  sx?: any,
}

export const DefaultCheckBox = ({
  disabled,
  isChecked,
  onChange,
  sx,
}: DefaultCheckBoxProps) => {
  return (
    <Checkbox
      disabled={disabled}
      checked={isChecked}
      icon={<></>}
      onClick={onChange}
      checkedIcon={<CheckIcon fontSize="inherit"/>}
      sx={{
        width: '24px',
        height: '24px',
        borderRadius: '6px',
        border: '1px solid #667085',
        fontSize: '16px',
        marginRight: '16px',

        '&:hover': {
          borderColor: '#BF295C',
          boxShadow: '#FFF2F7 0px 0px 0px 4px',
        },

        '&.Mui-checked': {
          backgroundColor: '#FFF8FA',
          borderColor: '#BF295C',
          color: '#F56193',
        },

        '& .MuiSvgIcon-root': {
          position: 'relative',
          top: '-1px',
        },

        visibility: disabled ? 'hidden' : 'visible',
        ...sx,
      }}
      disableRipple
    />
  )
}
